import { api } from '@api/api2';
import { UsersPayload, TicketsPayload, GetDeviceNamePayload } from '../../interfaces';

let getTicketsController: AbortController;
export const IGNORE_REQUEST_ERRORS = ['canceled'];

const getUsersInfo = (payload: UsersPayload) =>
  api.v1('post', 'tck/bms/users/list', payload);
const getTickets = (payload: TicketsPayload) => {
  if (getTicketsController) {
    getTicketsController.abort();
  }

  getTicketsController = new AbortController();

  return api.v1(
    'post',
    'tck/bms/tickets/list',
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    },
    getTicketsController.signal
  );
};
const getDeviceName = (payload: GetDeviceNamePayload) =>
  api.no_vers('get', 'bmsdevice/get-device-info', payload);
const exportTickets = (payload: TicketsPayload) =>
  api.v1('request', 'tck/bms/tickets/list/export', payload, {
    config: {
      responseType: 'arraybuffer',
    },
    method: 'post',
  });
const getTypesList = () => api.v4('get', 'ticket/types/list');

export const ticketsApi = {
  getUsersInfo,
  getTickets,
  getDeviceName,
  exportTickets,
  getTypesList,
};
